// import React, { useState } from "react";
// import TextComponent from "../../../components/textComponent/TextComponent";
// import styles from "./AdminDashboard.module.css";
// import { List, Progress } from "antd";
// import BarChart from "./BarChart/BarChart";
// import { BsThreeDots } from "react-icons/bs";
// import PieChart from "./PieChart/PieChart";
// import { Table } from "antd";
// import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";
// import { t } from "i18next";

// const columns = [
//   {
//     title: "No",
//     dataIndex: "No",
//     key: "No",
//   },
//   {
//     title: "Task",
//     dataIndex: "Task",
//     key: "Task",
//   },
//   {
//     title: "Time",
//     dataIndex: "Time",
//     key: "Time",
//   },
//   {
//     title: "Reason",
//     key: "Reason",
//     dataIndex: "Reason",
//   },
// ];
// const data = [
//   {
//     key: "1",
//     No: "1",
//     Task: "Dough and batter mixing",
//     Time: " 6:10 AM",
//     Reason: "Task flagged due to incorrect ingredient ratios.",
//   },
//   {
//     key: "2",
//     No: "2",
//     Task: "Baguettes, rolls, loaves",
//     Time: "7:00 AM",
//     Reason: "Proofing time or temperature was not followed.",
//   },
//   {
//     key: "3",
//     No: "3",
//     Task: "Filling, stacking, and crumb coating",
//     Time: "7:30 AM",
//     Reason:
//       "Oven temperature or baking time did not match production standards..",
//   },
//   {
//     key: "4",
//     No: "4",
//     Task: "Dough preparation and portioning",
//     Time: "7:30 AM",
//     Reason:
//       "Flagged for potential cross-contact with allergen-containing ingredients.",
//   },
//   {
//     key: "5",
//     No: "5",
//     Task: "Rotation of baked goods  ",
//     Time: " 7:45 AM",
//     Reason: "Items stored at incorrect temperature or humidity levels.",
//   },
//   {
//     key: "6",
//     No: "6",
//     Task: "Sealing and shelf-life management",
//     Time: " 7:45 AM",
//     Reason: "Packaging task incomplete or labeling missing.",
//   },
// ];

// const AdminDashboard = () => {
//   const OverviewData = [
//     {
//       id: 1,
//       logo: require("../../../assets/images/staticImages/OverviewIcon1.png"),
//       name: "Today’s Tasks",
//       price: 130,
//     },
//     {
//       id: 2,
//       logo: require("../../../assets/images/staticImages/OverviewIcon2.png"),
//       name: "Total Task",
//       price: 130,
//     },
//     {
//       id: 3,
//       logo: require("../../../assets/images/staticImages/OverviewIcon3.png"),
//       name: "Tasks Completed",
//       price: 130,
//     },
//   ];

//   const renderOverview = (item, index) => {
//     return (
//       <div className={styles.rj_listItem}>
//         <img src={item?.logo} style={{ width: "15% ", objectFit: "contian" }} />
//         <TextComponent padding={"0px"} text={item?.name} color={"#808080"} />
//         <TextComponent
//           padding={"0px"}
//           text={item?.price}
//           fontSize="var(--dashboard_tabs-font-size)"
//           fontFamily="Urbanist-bold"
//         />
//       </div>
//     );
//   };
//   const ActiveOrderData = [
//     {
//       id: 1,
//       name: "Sourdough",
//       percent: 80,
//       progress_color: "var(--progress-color-one)",
//     },
//     {
//       id: 2,
//       name: "White bread",
//       percent: 80,
//       progress_color: "var( --progress-color-two)",
//     },
//     {
//       id: 3,
//       name: "Baguettes",
//       percent: 80,
//       progress_color: "var(--progress-color-one)",
//     },
//   ];

//   const [chartData, setChartData] = useState({
//     labels: ["15%", "17%", "07%", "25%"],
//     datasets: [
//       {
//         label: "Wheat",
//         data: [15, 18, 7, 21],
//         backgroundColor: ["#D44E52", "#FF9F68", "#8B2F1F", "#BA2E0F"],
//         borderRadius: 10,
//         barPercentage: 1.2,
//         categoryPercentage: 0.5,
//       },
//     ],
//   });

//   const Colors = ["#D44E52", "#FF9F68", "#8B2F1F", "#BA2E0F"];

//   const renderActiveOrder = (item, index) => {
//     return (
//       <div className={styles.AO_listItem}>
//         <img src={item?.logo} style={{ width: "15% ", objectFit: "contain" }} />
//         <TextComponent text={item?.name} padding={"0px"} color={"#808080"} />
//         <div style={{ display: "flex", gap: "5px" }}>
//           <TextComponent
//             padding={"0px"}
//             text={`${item?.percent}% `}
//             fontSize="var(--dashboard_tabs-font-size)"
//             fontFamily="Poppins-semibold"
//           />
//           <TextComponent
//             padding={"0px"}
//             text={` completed`}
//             fontSize="var(--mobile-heading)"
//             fontFamily="Poppins-semibold"
//           />
//         </div>
//         <Progress
//           percent={100}
//           showInfo={false}
//           strokeColor={item.progress_color}
//         />
//       </div>
//     );
//   };

//   return (
//     <div className={styles.mainCon}>
//       <div className={styles.HeaderDiv}>
//         <TextComponent className={styles.WelcomeText} text={t("Welcome, ")} />
//         <TextComponent
//           text="Stacy!"
//           padding={"0px"}
//           className={styles.UserName}
//         />
//       </div>
//       <TextComponent text="Vintage Bakers" className={styles.BakeryName} />

//       <div className={styles.secondDiv}>
//         <div className={styles.OverviewDiv}>
//           <div className={styles.OverviewHeadingDiv}>
//             <TextComponent
//               text={t("Overview")}
//               className={styles.smallHeading}
//             />
//           </div>
//           <div>
//             <List
//               dataSource={OverviewData}
//               renderItem={renderOverview}
//               style={{ marginTop: 10 }}
//               grid={{
//                 gutter: 16,
//                 xs: 1,
//                 sm: 2,
//                 md: 2,
//                 lg: 3,
//                 xl: 3,
//                 xxl: 3,
//               }}
//             />
//           </div>
//         </div>
//         <div className={styles.OverviewDiv}>
//           <div className={styles.OverviewHeadingDiv}>
//             <TextComponent
//               className={styles.smallHeading}
//               text={t("Active Orders")}
//             />
//           </div>
//           <div className={styles.ActiveOrderDiv}>
//             <List
//               dataSource={ActiveOrderData}
//               renderItem={renderActiveOrder}
//               style={{ width: "100%" }}
//               grid={{
//                 gutter: 16,
//                 xs: 1,
//                 sm: 2,
//                 md: 2,
//                 lg: 3,
//                 xl: 3,
//                 xxl: 3,
//               }}
//             />
//           </div>
//         </div>
//       </div>
//       <div className={styles.BottomDiv}>
//         <div className={styles.GraphDiv}>
//           <div className={styles.BarGraphDiv}>
//             <div className={styles.row}>
//               <TextComponent
//                 text={t("Low Stock Alert")}
//                 className={styles.smallHeading}
//               />

//               <BsThreeDots style={{ cursor: "pointer" }} />
//             </div>
//             <BarChart chartData={chartData} />
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 marginTop: "10px",
//               }}
//             >
//               {Colors.map((color, index) => {
//                 const labels = ["Wheat", "Flour", "Sugar", "Salt"];
//                 return (
//                   <div key={index} className={styles.BarChartLabel}>
//                     <div
//                       style={{
//                         width: 12,
//                         height: 12,
//                         borderRadius: 4,
//                         backgroundColor: color,
//                         margin: "0 auto 5px",
//                       }}
//                     ></div>
//                     <div className={styles.LabelText}>{labels[index]}</div>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//           <div className={styles.PieChartDiv}>
//             <div className={styles.PieChartrow}>
//               <TextComponent
//                 text={t("Your User Licsenses")}
//                 className={styles.PieChartHeading}
//               />
//               <BsThreeDots style={{ cursor: "pointer" }} />
//             </div>
//             <div className={styles.PieChart}>
//               <PieChart />
//               <div className={styles.LegendDiv}>
//                 <div className={styles.BarChartLabel}>
//                   <div
//                     style={{
//                       width: 12,
//                       height: 12,
//                       borderRadius: "50%",
//                       backgroundColor: "#FD521B",
//                       margin: "0 auto 5px",
//                     }}
//                   ></div>
//                   <div>
//                     <TextComponent
//                       text="Available "
//                       className={styles.LegendText}
//                     />
//                     <TextComponent
//                       text=" 239 "
//                       style={{ fontSize: "var(--mobile-sub-heading)" }}
//                     />
//                   </div>
//                 </div>
//                 <div className={styles.BarChartLabel}>
//                   <div
//                     style={{
//                       width: 12,
//                       height: 12,
//                       borderRadius: "50%",
//                       backgroundColor: "#D24717",
//                       margin: "0 auto 5px",
//                     }}
//                   ></div>
//                   <div>
//                     <TextComponent
//                       text="Active "
//                       className={styles.LegendText}
//                     />
//                     <TextComponent
//                       text="139 "
//                       style={{ fontSize: "var(--mobile-sub-heading)" }}
//                     />
//                   </div>
//                 </div>
//                 <div className={styles.BarChartLabel}>
//                   <div
//                     style={{
//                       width: 12,
//                       height: 12,
//                       borderRadius: "50%",
//                       backgroundColor: "#FFA803",
//                       margin: "0 auto 5px",
//                     }}
//                   ></div>
//                   <div>
//                     <TextComponent
//                       text="Total "
//                       className={styles.LegendText}
//                     />
//                     <TextComponent
//                       text="339 "
//                       style={{ fontSize: "var(--mobile-sub-heading)" }}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className={styles.TableDiv}>
//           <div className={styles.TableDivRow}>
//             <TextComponent
//               text="Flagged Tasks"
//               className={styles.smallHeading} 
//             />

//             <BsThreeDots style={{ cursor: "pointer" }} />
//           </div>
//           <div>
//             <Table
//               scroll={{ x: true }}
//               columns={columns}
//               dataSource={data}
//               pagination={false}
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminDashboard;





import React, { useState } from "react";
import styles from "./AdminDashboard.module.css";
import { Dropdown, TextComponent } from "../../../components";
import { List, Table } from "antd";
import BarChart from "../AdminDashboard/BarChart/BarChart";
import { BsThreeDots } from "react-icons/bs";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";
import { t } from "i18next";
import HeaderComponent from "../../../components/HeaderComponent/HeaderComponent";

const AdminDashboard = () => {
  const [workDrop, setWorkDrop] = useState()
  const OverviewData = [
    {
      OrderID: 123,
      Department: "Today’s Tasks",
      StartTime: "11:25 pm",
      EndTime: "11:25 pm",
      OrderStatus: "In Progresss",
      color: "#C6450C",
    },
    {
      OrderID: 233,
      Department: "Today’s Tasks",
      StartTime: "11:25 pm",
      EndTime: "11:25 pm",
      OrderStatus: "In Progresss",
      color: "#F37E43",
    },
    {
      OrderID: 233,
      Department: "Today’s Tasks",
      StartTime: "11:25 pm",
      EndTime: "11:25 pm",
      OrderStatus: "In Progresss",
      color: "#AB3006",
    },
    {
      OrderID: 233,
      Department: "Today’s Tasks",
      StartTime: "11:25 pm",
      EndTime: "11:25 pm",
      OrderStatus: "In Progresss",
      color: "#C74D52",
    },
    {
      OrderID: 233,
      Department: "Today’s Tasks",
      StartTime: "11:25 pm",
      EndTime: "11:25 pm",
      OrderStatus: "In Progresss",
      color: "#822D12",
    },
  ];

  const renderOverview = (item, index) => {
    return (
      <div
        className={styles.rj_listItem}
        style={{
          backgroundColor: item?.color,
        }}
      >
        <div className={styles.Mini_Row}>
          <TextComponent text={"Order ID"} className={styles.CardText} />
          <TextComponent text={item?.OrderID} className={styles.CardText} />
        </div>
        <div className={styles.Mini_Row}>
          <TextComponent text={"Department"} className={styles.CardText} />
          <TextComponent text={item?.Department} className={styles.CardText} />
        </div>
        <div className={styles.Mini_Row}>
          <TextComponent text={"Start Time"} className={styles.CardText} />
          <TextComponent text={item?.StartTime} className={styles.CardText} />
        </div>
        <div className={styles.Mini_Row}>
          <TextComponent
            text={"End Time"}
            className={styles.CardText}
            color={"--var(white-color)"}
            fontSize={"var(--mobile-sub-heading)"}
            padding={"0px"}
          />
          <TextComponent
            text={item?.EndTime}
            className={styles.CardText}
            fontSize={"var(--mobile-sub-heading)"}
            color={"--var(white-color)"}
            padding={"0px"}
          />
        </div>
        <div className={styles.Mini_Row}>
          <TextComponent
            text={"Order Status"}
            className={styles.CardText}
            color={"--var(white-color)"}
            fontSize={"var(--mobile-sub-heading)"}
            padding={"0px"}
          />
          <TextComponent
            text={item?.OrderStatus}
            className={styles.CardText}
            color={"--var(white-color)"}
            fontSize={"var(--mobile-sub-heading)"}
            padding={"0px"}
          />
        </div>
      </div>
    );
  };

  const [chartData, setChartData] = useState({
    labels: ["15%", "17%", "21%", "25%", "21%", "21%"],
    datasets: [
      {
        label: "Wheat",
        data: [15, 18, 7, 21, 25, 25],
        backgroundColor: [
          "#C74D52",
          "#FB9A68",
          "#C74D52",
          "#822D12",
          "#F39C12",
          "#AB3006",
        ],
        borderRadius: 10,
        borderColor: "transparent",
        barPercentage: 0.7,
        categoryPercentage: 0.5,
      },
    ],
  });

  const columns = [
    {
      title: "Role",
      dataIndex: "Role",
      key: "Role",
    },
    {
      title: "Mixing",
      dataIndex: "Mixing",
      key: "Mixing",
    },
    {
      title: "Assembly",
      dataIndex: "Assembly",
      key: "Assembly",
    },
    {
      title: "Make Up",
      key: "MakeUp",
      dataIndex: "MakeUp",
    },
    {
      title: "Proofing",
      key: "Proofing",
      dataIndex: "Proofing",
    },
    {
      title: "Oven",
      key: "Oven",
      dataIndex: "Oven",
    },
    {
      title: "Packaging",
      key: "Packaging",
      dataIndex: "Packaging",
    },
  ];
  const data = [
    {
      Role: "Staff Member",
      Mixing: "04",
      Assembly: "14",
      MakeUp: "13",
      Proofing: "13",
      Oven: "18",
      Packaging: "19",
    },
    {
      Role: "Staff Member",
      Mixing: "04",
      Assembly: "14",
      MakeUp: "13",
      Proofing: "13",
      Oven: "18",
      Packaging: "19",
    },
    {
      Role: "Staff Member",
      Mixing: "04",
      Assembly: "14",
      MakeUp: "13",
      Proofing: "13",
      Oven: "18",
      Packaging: "19",
    },
  ];

  const Colors = [
    "#C74D52",
    "#FB9A68",
    "#C74D52",
    "#822D12",
    "#F39C12",
    "#AB3006",
  ];

  return (
    <div className={styles.mainCon}>
      <div className={styles.HeaderDiv}>
        <TextComponent className={styles.WelcomeText} text={t("Welcome, ")} />
        <TextComponent
          text="Stacy!"
          padding={"0px"}
          className={styles.UserName}
        />
      </div>
      <TextComponent text="Vintage Bakers" className={styles.BakeryName} />

      <div className={styles.SubMainCont}>
        {/* <div className={styles.TaskFeedDiv}>
          <TextComponent
            text={t("Live Task Feed ")}
            className={styles.TaskFeedHeading}
          />
          <div>
            <List
              dataSource={OverviewData}
              renderItem={renderOverview}
              style={{ marginTop: 10 }}
              grid={{
                gutter: [0, 16],
                xs: 1,
                sm: 2,
                md: 3,
                lg: 5,
                xl: 5,
                xxl: 5,
              }}
            />
          </div>
        </div> */}
        <div className={styles.BarChartDiv}>
          <div className={styles.workDropCont}>
            <TextComponent
              text={t("Workload Distribution Snapshot")}
              className={styles.BarChartHeading}
            />

            <Dropdown
              placeholder={"Select"}
              className={styles.workDrop}
              value={workDrop}
              options={[
                {
                  value: "All	",
                  role: "all	",
                  id: 1,
                },
                {
                  value: "Mixing",
                  role: "InventMixingory",
                  id: 2,
                },
              ]}
              onChange={(e) => setWorkDrop(e)}
            />

          </div>

          <BarChart chartData={chartData} />
        </div>
        <div className={styles.BarChartRow}>
          {Colors.map((color, index) => {
            const labels = [
              "Mixing",
              "Assembly",
              "Proofing",
              "Oven",
              "Make Up",
              "Packaging",
            ];
            return (
              <div key={index} className={styles.BarChartLabel}>
                <div
                  style={{
                    width: 12,
                    height: 12,
                    borderRadius: 4,
                    backgroundColor: color,
                    margin: "0 auto 5px",
                  }}
                ></div>
                <div className={styles.LabelText}>{labels[index]}</div>
              </div>
            );
          })}
        </div>

        <div className={styles.TableDiv}>
          <div className={styles.TableDivRow}>
            <TextComponent
              text={t("Attendance Viewer")}
              className={styles.TableHeading}
            />
            <Dropdown
              placeholder={"Select"}
              className={styles.workDrop}
              value={workDrop}
              options={[
                {
                  value: "All	",
                  role: "all	",
                  id: 1,
                },
                {
                  value: "Mixing",
                  role: "InventMixingory",
                  id: 2,
                },
              ]}
              onChange={(e) => setWorkDrop(e)}
            />

          </div>
          <div>
            <Table
              scroll={{ x: true }}
              columns={columns}
              dataSource={data}
              pagination={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;


